import React from 'react';
import Image2 from '@atlassian/jira-illustrations/src/ui/adg4/brand/spots/objects/components/blueprint/index.tsx';
import Image3 from '@atlassian/jira-illustrations/src/ui/adg4/jira/spots/software/components/ticket-bulb-chat/index.tsx';
import Image1 from '@atlassian/jira-illustrations/src/ui/adg4/jira/spots/success/components/approved-file/index.tsx';
import type { TemplateStaticContent } from '../../../../common/types.tsx';
import { ResizedImageWrapper } from '../../../../common/ui/resized-image-wrapper/index.tsx';
import commonJPDMessages from '../messages.tsx';
import messages from './messages.tsx';

export const TEMPLATE_KEY = 'jpd.product-discovery' as const;

export const productDiscovery: TemplateStaticContent = {
	key: TEMPLATE_KEY,
	overviewContent: {
		valueProps: [
			{
				title: messages.valueProp1Title,
				description: messages.valueProp1Description,
				imageUrl: '',
				imageComponent: () => <Image1 alt="" />,
			},
			{
				title: messages.valueProp2Title,
				description: messages.valueProp2Description,
				imageUrl: '',
				imageComponent: () => (
					<ResizedImageWrapper>
						<Image2 alt="" />
					</ResizedImageWrapper>
				),
			},
			{
				title: messages.valueProp3Title,
				description: messages.valueProp3DescriptionSpork,
				imageUrl: '',
				imageComponent: () => <Image3 alt="" />,
			},
		],
		recommendedList: [messages.recommendedList1, messages.recommendedList2],
		workType: 'Issue',
		issueTypes: [{ key: 'idea', label: commonJPDMessages.idea }],
		workflow: [
			{ label: commonJPDMessages.parkingLot, appearance: 'default' },
			{ label: commonJPDMessages.discovery, appearance: 'inprogress' },
			{ label: commonJPDMessages.readyForDelivery, appearance: 'inprogress' },
			{ label: commonJPDMessages.delivery, appearance: 'inprogress' },
			{ label: commonJPDMessages.impact, appearance: 'inprogress' },
			{ label: commonJPDMessages.archived, appearance: 'success' },
		],
	},
};
